<template>
  <div class="home">
    <img alt="Vue logo" src="/favicon.ico" style="width: 128px; margin: 48px 0;"></img>
    <HelloWorld/>
  </div>
</template>
<script>
import HelloWorld from '@/components/HelloWorld.vue'
export default {
  name: 'HomeView',
  components: {
    HelloWorld,
  },
}
</script>
<style lang="less" scoped>
.home {
  text-align: center;
}
</style>
